import { IEmpresaRegimeTributario } from "../interfaces/IEmpresaRegimeTributario";
import api from "./Api";

class EmpresaRegimeTributarioService {
    async obterPorId(empresaRegimeTributarioID: number): Promise<IEmpresaRegimeTributario[]> {
        const { data: result } = await api.get<IEmpresaRegimeTributario[]>(`EmpresaRegimeTributario/${empresaRegimeTributarioID}`);

        return result;
    }

    async criar(empresaRegimeTributario: IEmpresaRegimeTributario): Promise<IEmpresaRegimeTributario> {
        const { data: result } = await api.post('EmpresaRegimeTributario', empresaRegimeTributario);

        return result;
    }

    async atualizar(empresaRegimeTributario: IEmpresaRegimeTributario): Promise<IEmpresaRegimeTributario> {
        const { data: result } = await api.put(`EmpresaRegimeTributario/${empresaRegimeTributario.id}`, empresaRegimeTributario);

        return result;
    }

    async excluir(empresaRegimeTributarioID: number): Promise<void> {
        const { data: result } = await api.delete(`EmpresaRegimeTributario/${empresaRegimeTributarioID}`);

        return result;
    }
}


export default new EmpresaRegimeTributarioService();